import React, { useState } from 'react'
import { useMemo } from 'react'
import { Input, FormCustom, Select } from '../../Components/Form/Form'
import Helpers from '../../Components/Helpers/Helpers'
import { toast } from 'react-toastify';

const SaleTrackerForm = ({ data, onSubmit, disablebSubmit, loadSubmit }) => {
    const [row, setRow] = useState({
        p_id_sale: data.id_sale,
        p_provider_name: data.provider_name,
        p_guide_number: data.guide_number,
        p_send_date: data.send_date,
        p_is_create: data.date_created === '',
        p_status_dispatch: data.status_dispatch
    })

    const statusOptions = [
        { value: 'ENVIADO', label: 'ENVIADO' },
        { value: 'RECHAZADO', label: 'RECHAZADO' },
        { value: 'ENTREGADO', label: 'ENTREGADO' },
        { value: 'PERDIDO', label: 'PERDIDO' },
        { value: 'MAL ESTADO', label: 'MAL ESTADO' },
    ]

    const cboStatus = useMemo(() => {
        if (!row.p_status_dispatch) {
            return ''
        }

        let finded = statusOptions.find(t => row.p_status_dispatch === t.value)

        if (!finded) {
            return ''
        }
        return finded
    }, [row.p_status_dispatch])

    return <FormCustom dataSubmit={row} onSubmit={({ data }) => {
        if (!row.p_status_dispatch) {
            Helpers.toast.construct({
                response: 'warning',
                message: 'El campo estado es obligatorio.',
                toast
            })
            return false
        }

        onSubmit({ data })
    }} disablebSubmit={disablebSubmit} loadSubmit={loadSubmit}>
        <Input
            text="ID Venta"
            placeholder="ID Venta"
            type="number"
            classNameParent="col-12 mb-2"
            icon="fas fa-sort-numeric-up"
            required
            invalid="El campo es obligatorio."
            defaultValue={data.id_sale}
            onChange={e => setRow({ ...row, p_id_sale: e.currentTarget.value })}
            maxLength={150}
            disabled={data.date_created !== ''}
        />
        <Input
            text="Paquetería"
            placeholder="Paquetería"
            classNameParent="col-12 mb-2"
            icon="far fa-comment-alt"
            required
            invalid="El campo es obligatorio."
            maxLength={150}
            defaultValue={data.provider_name}
            onChange={e => setRow({ ...row, p_provider_name: e.currentTarget.value })}
        />
        <Input
            text="Número Guía"
            placeholder="Número Guía"
            classNameParent="col-12 mb-2"
            icon="far fa-comment-alt"
            required
            invalid="El campo es obligatorio."
            maxLength={150}
            defaultValue={data.guide_number}
            onChange={e => setRow({ ...row, p_guide_number: e.currentTarget.value })}
        />
        <Input
            text="Fecha Envío"
            placeholder="Fecha Envío"
            classNameParent="col-12 mb-2"
            icon="far fa-calendar-alt"
            required
            invalid="El campo es obligatorio."
            defaultValue={data.send_date}
            type="date"
            onChange={e => setRow({ ...row, p_send_date: e.currentTarget.value })}
        />
        <Select
            classNameParent={'col-12 mb-2'}
            icon="far fa-building"
            text="Estado"
            options={statusOptions}
            value={cboStatus}
            onChange={e => {
                setRow({ ...row, p_status_dispatch: e.value })
            }}
        />
    </FormCustom>
}

SaleTrackerForm.defaultProps = {
    data: {
        id_sale: '',
        provider_name: '',
        guide_number: '',
        send_date: '',
        date_created: '',
        status_dispatch: '',
    },
    onSubmit: () => { },
    loadSubmit: false
}

export default SaleTrackerForm;